import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NotificationComponent } from './notification.component';
import { ApproveNotificationComponent } from './approve-notification/approve-notification.component';
import { ViewNotificationComponent } from './view-notification/view-notification.component';

const routes: Routes = [
    {
      path: '',
      canActivate: [AuthGuard],
      children: [
        {
          path: '',
          component: NotificationComponent,
          canActivate: [AuthGuard],
        },
        {
          path: 'approve-notifications',
          children: [{
            path: '',
            component: ApproveNotificationComponent,
            canActivate: [AuthGuard]
          }]
        },
        {
          path: 'view-notification/:id',
          data: {
              breadcrumb: 'view-notification'
          },
          children: [
              {
                  path: '',
                  component: ViewNotificationComponent,
                  canActivate: [AuthGuard]
              }
          ]
      },
      ]
    }
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class NotificationRoutingModule {}